module.exports = __webpack_public_path__ + "img/54_48.4788e030.png";